// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import VueEvents from 'vue-events'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate'
import App from './App'
import store from './store'
import translations from '@/translations'
import api from './services/api'
import moment from 'moment'
import HasRole from '@/directives/hasRole'
import Prompt from '@/components/prompt'
import {formatDate, formatTime, formatDateTime, formatAge} from './filters'

Vue.use(VueEvents)
Vue.use(VueI18n)
Vue.use(VeeValidate, {fieldsBagName: 'formFields'})
Vue.use(HasRole)
Vue.use(Prompt)

Vue.filter('formatDate', formatDate)
Vue.filter('formatTime', formatTime)
Vue.filter('formatDateTime', formatDateTime)
Vue.filter('formatAge', formatAge)

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: store.state.language,
  messages: translations
})

let lang = i18n.locale
if (lang === 'rs') lang = 'sr-cyrl'
if (lang === 'si') lang = 'sr-lat'
moment.locale(lang)

Object.defineProperty(Vue.prototype, '$api', { value: api.getInstance() })
Object.defineProperty(Vue.prototype, '$moment', { value: moment })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js